import React, { Component } from 'react';
import { Table, Popover, OverlayTrigger } from "react-bootstrap";
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'qrcode.react';

import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';

import { ConsultCuentaAdmin } from "../../../funciones/EstCuentaFunction";
import { SolicSolvencia } from "../../../funciones/CobranzasFunction";
import SolvenciaAdmin from "../../../components/Reportes/SolvenciaAdmin";
import { SvgToPng } from "../../../funciones/AdmisionFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

class EstSolvenciaTable extends Component {
    state = {
        openCuenta: false,
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
        asientos: [],
        openW: false,
        datos: "",
        botonSolv: {
            icon: "fa fa-gear",
            text: "Acciones"
        },
        qr: ""
    }

    modalReporte = () => {
        let { datos, autoridad } = this.props;
        let { openW, qr } = this.state;

        if (openW === false || datos.Status === false) return null;
        
        let contenidoModal = () => {
            let { datos } = this.state;

            return (
                <SolvenciaAdmin datos = {datos} QrCode = {qr} autoridad = {autoridad}/>
            )
        }

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo={`Solvencia Administrativa de ${datos.Estudiante}`}
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
            />
        )
    }

    modalCuenta = () => {
        let { openCuenta, asientos, preloader } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let contentEstado = () => {
            if (asientos.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">{preloader}</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                asientos.map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let contenidoModal = () => (
            <React.Fragment>
                <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                <td width="40%" style={styles}><strong>Descripción</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                <td width="30px" align="center" style={styles}></td>
                            </tr>
                            {contentEstado()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-times"></i> Cerrar</React.Fragment>}
                large = "large"
                isopen =  {openCuenta}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Estado de Cuenta de <strong>{this.props.datos.Estudiante}</strong></div>}
                contenido = {contenidoModal()}      
                funcion1 = {() => {this.setState({
                    openCuenta: false,
                    asientos: [],
                    preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
                })}}
            />
        );
    }

    render() {
        let { datos } = this.props;
        let { botonSolv, qr } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 11
        }

        let icono = () => {
            let text = "text-danger fa fa-times-circle"
            if (datos.Status === true) text = "text-success fa fa-check-circle";

            return text;
        }

        let solvencia = () => {
            if (datos.Status === false) return null;

            return (
                <div className="text-success" onClick={() => {
                    if (datos.Status === false) return null;

                    this.setState({
                        botonSolv: {
                            icon: "fa fa-spinner fa-spin",
                            text: "Espera"
                        }
                    }, () => {
                        SolicSolvencia (datos.id, (resp) => {
                            let imgSvg = (
                                <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${resp.token}`}/>
                            )
                
                            const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                            const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
                
                            SvgToPng (dataUri, (qr) => {
                                this.setState({
                                    datos: resp,
                                    openW: true,
                                    botonSolv: {
                                        icon: "fa fa-gear",
                                        text: "Acciones"
                                    },
                                    qr: qr
                                })
                            })
                        })
                    })
                }} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Generar Solvencia"><i className="fa fa-file"></i> Generar Solvencia</div>
            )
        }

        let menu = (
            <Popover bsSize="large" id="acciones">
                <div className="text-danger" onClick={() => {
                    this.setState({
                        openCuenta: true
                    }, () => {
                        ConsultCuentaAdmin (datos.id, (resp)=> {
                            this.setState({
                                asientos: resp
                            })
                        })
                    }) }} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver Estado de Cuenta"><i className="fa fa-money"></i> Estado de Cuenta</div>
                {solvencia()}
            </Popover>
        )

        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>{datos.Estudiante}</td>
                    <td align="center" style={styles2}>{datos.Carrera}</td>
                    <td align="center" style={styles}><i className={icono()}></i> {datos.Deuda}</td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={menu}>
                            <button className="btn btn-primary" title= "Haz click aqui para ver las opciones disponibles" style={{borderWidth: 1}}><i className={botonSolv.icon}></i> {botonSolv.text}</button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalCuenta()}
                {this.modalReporte()}
            </React.Fragment>
        );
    }
}
 
export default EstSolvenciaTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/EstSolvenciaTable.jsx